import { Injectable } from '@angular/core';
import {HttpClient} from "@angular/common/http";
import {CargGroup} from "../models/carg.model";
import {Observable} from "rxjs";
import {environment} from "../../environments/environment";

@Injectable({
  providedIn: 'root'
})
export class CargService {

  private apiUrl = `${environment.apiUrl}/cargs/`;

  constructor(private http: HttpClient) {}

  getCargs(): Observable<CargGroup[]> {
    return this.http.get<CargGroup[]>(this.apiUrl);
  }

}
